import { ConsultsActionTypes } from './consults-actions';

export const initialState = {
  loading: false,
  hashUserId: undefined,
  slug: undefined,
  defaultDrText: undefined,
  userInfo: {},
  datatable: [],
  datatableIsLoading: false,
  hasAlreadyQuestion: {},
  allowToAnswer: false,
  openData: undefined,
  checkOpenData: false,
  content: undefined,
  file: undefined,
  storeLoading: false,
  startChat: false,
  fileType: undefined,
  fileResponse: undefined,
  fileLoading: false,
  closePreview: false,
  currentPage: 0,
  lastPage: 0,
  extendedDatatableLoading: false,
  city: {
    id: undefined,
    name: undefined,
    title: undefined,
  },
  cityModal: false,
  electronicPrescriptionLoading: false,
  consultDialogueId: null,
};

function consultsReducer(state = initialState, action: any) {
  switch (action.type) {
    case ConsultsActionTypes.GET_DATATABLE_INFO:
      return {
        ...state,
        hashUserId: action.hashUserId || undefined,
        currentPage: initialState.currentPage,
      };

    case ConsultsActionTypes.SET_DATATABLE:
      return {
        ...state,
        datatable: state.currentPage === 0 ? action?.data?.data : [...state.datatable, ...action?.data?.data],
        lastPage: action?.data?.lastPage,
        currentPage: action?.data?.currentPage,
        datatableIsLoading: false,
        extendedDatatableLoading: false,
      };

    case ConsultsActionTypes.SET_NEW_CHAT_CONTENT:
      return {
        ...state,
        datatable: [
          action?.data,
          ...state.datatable,
        ],
      };

    case ConsultsActionTypes.CHECK_OPEN_DATA:
      return {
        ...state,
        hasAlreadyQuestion: action?.hasAlreadyQuestion,
      };

    case ConsultsActionTypes.SET_CONSULTS_OPEN_DATA:
      return {
        ...state,
        allowToAnswer: action?.data?.allowToAnswer,
        openData: action?.data?.openData,
        checkOpenData: action?.data?.checkOpenData,
      };

    case ConsultsActionTypes.STORE_DIALOG_BOX:
      return {
        ...state,
        content: action?.data?.content || '',
        storeLoading: true,
        lastPage: initialState.lastPage,
        currentPage: initialState.currentPage,
      };

    case ConsultsActionTypes.STORE_CONSULT:
      return {
        ...state,
        content: action?.content || '',
        storeLoading: true,
      };

    case ConsultsActionTypes.SET_CHAT_CONTENT:
      return {
        ...state,
        content: action?.data?.content || '',
      };

    case ConsultsActionTypes.STORE_DIALOG_BOX_LOADING:
      return {
        ...state,
        storeLoading: action?.storeLoading || false,
        closePreview: true,
        fileLoading: action?.fileLoading || false,
      };

    case ConsultsActionTypes.SET_START_CHAT:
      return {
        ...state,
        startChat: action?.startChat || false,
      };

    case ConsultsActionTypes.SET_FILE_RESPONSE:
      return {
        ...state,
        fileResponse: action?.data?.fileResponse,
        lastPage: initialState.lastPage,
        currentPage: initialState.currentPage,
        fileLoading: false,
      };

    case ConsultsActionTypes.SET_FILE_INITIAL_STATE:
      return {
        ...state,
        fileResponse: initialState.fileResponse,
        file: initialState.file,
        fileType: initialState.fileType,
        fileLoading: false,
        closePreview: initialState.closePreview,
      };

    case ConsultsActionTypes.SET_CHAT_FILE:
      return {
        ...state,
        file: action?.data?.file || initialState.file,
        fileType: action?.data?.fileType || initialState.fileType,
        fileLoading: true,
        content: action?.data?.content || initialState.content,
      };

    case ConsultsActionTypes.GET_EXTENDED_DATATABLE:
      return {
        ...state,
        extendedDatatableLoading: true,
      };

    case ConsultsActionTypes.SET_INITIAL_STATE:
      return {
        ...initialState,
      };

    case ConsultsActionTypes.SET_CONSULT_DIALOGUE_ID:
      return {
        ...state,
        consultDialogueId: action?.data?.id || state.consultDialogueId,
      };

    case ConsultsActionTypes.GET_ELECTRONIC_PRESCRIPTION:
      return {
        ...state,
        electronicPrescriptionLoading: true,
      };

    case ConsultsActionTypes.SET_ELECTRONIC_PRESCRIPTION:
      return {
        ...state,
        electronicPrescriptionLoading: false,
      };

    default:
      return state;
  }
}

export default consultsReducer;
